import React from 'react';
import { UsersIcon, SearchIcon, BarChartIcon } from 'lucide-react';
const Slide3 = () => {
  return <section className="slide bg-white rounded-lg p-8 md:p-12 overflow-hidden" data-id="element-2599">
      <div className="flex flex-col space-y-6" data-id="element-2600">
        {/* Title */}
        <h2 className="text-3xl font-bold text-center mb-6" data-id="element-2601">
          Sales Advisors + Knowledge Base
        </h2>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-2602">
          {/* Left Column - Sales Advisors */}
          <div data-id="element-2603">
            <div className="bg-indigo-50 rounded-lg p-6 border border-indigo-200 h-full" data-id="element-2604">
              <h3 className="text-xl font-semibold text-indigo-800 mb-4" data-id="element-2605">
                Advisors
              </h3>
              <ul className="space-y-3 text-gray-700" data-id="element-2606">
                <li className="flex items-start gap-2" data-id="element-2607">
                  <div className="w-2 h-2 bg-indigo-500 rounded-full mt-2" data-id="element-2608"></div>
                  <span data-id="element-2609">Need-based consultative flows</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-2610">
                  <div className="w-2 h-2 bg-indigo-500 rounded-full mt-2" data-id="element-2611"></div>
                  <span data-id="element-2612">Know catalog better than humans</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-2613">
                  <div className="w-2 h-2 bg-indigo-500 rounded-full mt-2" data-id="element-2614"></div>
                  <span data-id="element-2615">Drive AOV</span>
                </li>
              </ul>
              <div className="mt-6 bg-white rounded-lg p-4 border border-gray-200" data-id="element-2616">
                <h4 className="font-medium text-gray-800 mb-2" data-id="element-2617">
                  ChatGPT Integration
                </h4>
                <p className="text-sm text-gray-600" data-id="element-2618">
                  Push products directly into ChatGPT so customers can purchase
                  there.
                </p>
                <div className="mt-3 flex items-center gap-2" data-id="element-2619">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-2620">
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#10A37F" data-id="element-2621" />
                    <path d="M16.2479 8.93296C16.5151 8.00226 16.0979 7.01463 15.2177 6.58359C14.3376 6.15256 13.2774 6.44438 12.7288 7.26858C12.1803 6.44438 11.1201 6.15256 10.2399 6.58359C9.35968 7.01463 8.94252 8.00226 9.20967 8.93296C8.34482 9.22252 7.75 10.0388 7.75 11C7.75 11.9612 8.34482 12.7775 9.20967 13.067C8.94252 13.9977 9.35968 14.9854 10.2399 15.4164C11.1201 15.8474 12.1803 15.5556 12.7288 14.7314C13.2774 15.5556 14.3376 15.8474 15.2177 15.4164C16.0979 14.9854 16.5151 13.9977 16.2479 13.067C17.1128 12.7775 17.7076 11.9612 17.7076 11C17.7076 10.0388 17.1128 9.22252 16.2479 8.93296Z" fill="white" data-id="element-2622" />
                  </svg>
                  <span className="text-sm font-medium" data-id="element-2623">ChatGPT Plugin</span>
                </div>
              </div>
              {/* Chat UI Visualization */}
              <div className="mt-6 bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-2624">
                <div className="bg-indigo-600 text-white px-4 py-2 flex justify-between items-center" data-id="element-2625">
                  <span className="font-medium" data-id="element-2626">Shopping Advisor</span>
                  <div className="flex items-center gap-2" data-id="element-2627">
                    <div className="w-2 h-2 bg-green-400 rounded-full" data-id="element-2628"></div>
                    <span className="text-xs" data-id="element-2629">Online</span>
                  </div>
                </div>
                <div className="p-3 max-h-40 overflow-y-auto" data-id="element-2630">
                  <div className="flex flex-col gap-2" data-id="element-2631">
                    <div className="bg-indigo-50 text-indigo-800 p-2 rounded-lg text-sm max-w-[80%]" data-id="element-2632">
                      How can I help you find the perfect product today?
                    </div>
                    <div className="bg-gray-100 text-gray-800 p-2 rounded-lg text-sm max-w-[80%] self-end" data-id="element-2633">
                      I'm looking for a new coffee maker
                    </div>
                    <div className="bg-indigo-50 text-indigo-800 p-2 rounded-lg text-sm max-w-[80%]" data-id="element-2634">
                      Great! What type of coffee do you usually drink and how
                      many people will be using it?
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Right Column - Knowledge Base */}
          <div data-id="element-2635">
            <div className="bg-green-50 rounded-lg p-6 border border-green-200 h-full" data-id="element-2636">
              <h3 className="text-xl font-semibold text-green-800 mb-4" data-id="element-2637">
                Knowledge Base
              </h3>
              <p className="text-gray-700 mb-6" data-id="element-2638">
                Empowers offline store reps & backoffice with instant answers.
              </p>
              {/* Staff visualization */}
              <div className="flex justify-center mb-6" data-id="element-2639">
                <div className="flex -space-x-4" data-id="element-2640">
                  {[...Array(4)].map((_, i) => <div key={i} className="w-12 h-12 rounded-full bg-white border-2 border-green-100 flex items-center justify-center" data-id="element-2641">
                      <UsersIcon className="h-6 w-6 text-green-600" data-id="element-2642" />
                    </div>)}
                </div>
              </div>
              {/* Knowledge search UI */}
              <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-2643">
                <div className="flex items-center gap-2 mb-4" data-id="element-2644">
                  <SearchIcon className="h-5 w-5 text-gray-500" data-id="element-2645" />
                  <input type="text" placeholder="Search knowledge base..." className="w-full border border-gray-200 rounded-lg py-2 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-green-500" defaultValue="Product return policy" data-id="element-2646" />
                </div>
                <div className="space-y-3" data-id="element-2647">
                  <div className="p-3 border border-green-200 rounded-lg bg-green-50" data-id="element-2648">
                    <h4 className="font-medium text-green-800 mb-1" data-id="element-2649">
                      Return Policy for Electronics
                    </h4>
                    <p className="text-sm text-gray-700" data-id="element-2650">
                      <mark className="bg-green-200 text-green-800" data-id="element-2651">
                        Electronics can be returned within 30 days
                      </mark>{' '}
                      of purchase with original receipt. Items must be in
                      original packaging with all accessories.
                    </p>
                  </div>
                  <div className="p-3 border border-gray-200 rounded-lg" data-id="element-2652">
                    <h4 className="font-medium text-gray-800 mb-1" data-id="element-2653">
                      Sales assistance support
                    </h4>
                    <p className="text-sm text-gray-700" data-id="element-2654">
Sales support can access internal knowledge base to get advice on common and complex consumers                       tags attached and be unworn.
                    </p>
                  </div>
                  <div className="p-3 border border-gray-200 rounded-lg" data-id="element-2655">
                    <h4 className="font-medium text-gray-800 mb-1" data-id="element-2656">
                      Food Items Return Policy
                    </h4>
                    <p className="text-sm text-gray-700" data-id="element-2657">
                      Perishable food items cannot be returned. Non-perishable
                      items can be returned within 7 days.
                    </p>
                  </div>
                </div>
              </div>
              {/* Analytics visualization */}
              <div className="mt-6 bg-white rounded-lg border border-gray-200 p-4" data-id="element-2658">
                <div className="flex items-center justify-between mb-3" data-id="element-2659">
                  <h4 className="font-medium text-gray-800" data-id="element-2660">
                    Knowledge Effectiveness
                  </h4>
                  <BarChartIcon className="h-5 w-5 text-green-600" data-id="element-2661" />
                </div>
                <div className="space-y-2" data-id="element-2662">
                  <div data-id="element-2663">
                    <div className="flex justify-between text-xs text-gray-600 mb-1" data-id="element-2664">
                      <span data-id="element-2665">Query Resolution Rate</span>
                      <span data-id="element-2666">92%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2667">
                      <div className="bg-green-600 h-2 rounded-full" style={{
                      width: '92%'
                    }} data-id="element-2668"></div>
                    </div>
                  </div>
                  <div data-id="element-2669">
                    <div className="flex justify-between text-xs text-gray-600 mb-1" data-id="element-2670">
                      <span data-id="element-2671">Staff Satisfaction</span>
                      <span data-id="element-2672">88%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2673">
                      <div className="bg-green-600 h-2 rounded-full" style={{
                      width: '88%'
                    }} data-id="element-2674"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Slide3;